import * as core from '../../../../../../../core'

import { query } from './high-priority-table.query'

export const RESOURCE = {
  payload: {
    alias: 'high.priority.table',
    description: 'Table view of high-priority stakeholders',
    name: 'High Priority Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
